// src/seo/site.js
// 站点级 SEO 配置与工具。
// 注意：domain / 组织信息为占位，落地时以正式备案信息与品牌资料为准。

export const SITE = {
  name: '衣创社区',
  // 正式域名（含协议）：http://yichuanghub.com（裸域，已拍板 2026-10-24）
  domain: 'http://yichuanghub.com',
  // 组织信息：落地时补全营业执照名称、联系方式、社媒主页等
  organization: {
    legalName: '衣创社区',
    logo: '/favicon.ico', // 建议替换为绝对地址且为正方形 PNG（>=112x112）
    telephone: '',
    email: '',
    sameAs: [], // 微信公众号/微博/小红书/知乎 等主页
  },
}

// 拼接绝对 URL：优先使用真实访问域（CSR 下 window.location.origin），保证 canonical/og:url 正确。
// 预渲染时，prerender.js 通过 window.__PRERENDER_INJECTED.seoDomain 注入正式域名，
// 避免快照里出现 127.0.0.1 等本地地址（爬虫无法识别）。
export function siteUrl(path = '') {
  let base = SITE.domain
  if (typeof window !== 'undefined') {
    const injected =
      window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.seoDomain
    if (injected) {
      base = injected
    } else if (window.location && window.location.origin) {
      base = window.location.origin
    }
  }
  if (!path) return base
  return base + (path.startsWith('/') ? path : '/' + path)
}

// 把相对/绝对图片地址规范为绝对地址（JSON-LD image / og:image 必须为绝对地址）
export function toAbsoluteUrl(u) {
  if (!u) return ''
  if (/^https?:\/\//.test(u)) return u
  return siteUrl(u)
}

// 把数字时间戳（秒）或字符串转为 ISO 8601（JSON-LD 日期字段要求）
export function toIso(value) {
  if (!value) return ''
  if (/^\d{10}$/.test(String(value))) return new Date(Number(value) * 1000).toISOString()
  if (/^\d{13}$/.test(String(value))) return new Date(Number(value)).toISOString()
  const d = new Date(value)
  return isNaN(d.getTime()) ? '' : d.toISOString()
}
